import SwitchTableVariantButtons from './SwitchTableVariantButtons';

export default SwitchTableVariantButtons;
